import { SurroundSound20Icon } from './SurroundSound20Icon';

/**
 * author: Austin Andrews
 * id 13009B66-7459-4C86-8EB0-3CAED977BB98
 * name surround-sound-2-0
 * version: 2.0.46
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/surround-sound-2-0.svg
 * tags
 * - Audio 
 */
export const StereoIcon = SurroundSound20Icon;
export default StereoIcon